export enum Profile {
    ADMIN = 'Administrateur',
    TRAINEE = 'Stagiaire'
}
